import { render, staticRenderFns } from "./DialogEditExtract.vue?vue&type=template&id=89b7b376"
import script from "./DialogEditExtract.vue?vue&type=script&lang=js"
export * from "./DialogEditExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports